<template>
  <v-toolbar dark>
    <v-toolbar-title class="white--text upper">{{ title }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn v-for="(button,index) of buttons" :key="index" class="mx-2" color="primary"
           :to="{ name: button.route }"
    >
      {{ button.name }}
    </v-btn
    >

    <v-text-field v-if="searchFilter || searchLocalFilter"
                  v-stream:input.native='search$'
                  hide-no-data
                  hide-selected
                  @input="searchLocal"
                  class="ml-2"
                  style="max-width: 250px;"
                  label="Поиск"
                  outlined
                  solo
                  hide-details
                  single-line
                  light
                  dense
                  return-object
    ></v-text-field>

  </v-toolbar>
</template>

<script>
import {debounceTime, distinctUntilChanged, filter, pluck, switchMap} from "rxjs/operators";
import {coreApi} from "~/services/core";

export default {
  props: {
    buttons: Array,
    title: String,
    items: Array,
    serviceName: {
      type: String
    },
    searchFilter: Function,
    searchLocalFilter: Function,
  },
  domStreams: ['search$'],
  subscriptions() {
    return {
      searchByOther$: this.search$.pipe(
          debounceTime(1000),
          filter(value => this.serviceName),
          pluck('event', 'target', 'value'),
          distinctUntilChanged(),
          filter(value => {
            const val = value.toString().trim()
            if (val.length === 0) {
              this.search(false)
            }
            return val.length !== 0
          }),
          switchMap(query => {
            coreApi.get(`finder?service=${this.serviceName}&q=${query}`).then(data => {
              this.search(data.data?.filter(obj => !obj.IsDeleted))
            })
            return Promise.resolve({})
          })
      ),
    }
  },
  computed: {
    search() {
      return this.searchFilter || ((v) => v)
    },
    searchLocal() {
      return this.searchLocalFilter || ((v) => v)
    }
  },
  mounted() {
    this.objects = this.items
  },
  data: () => ({
    searchValue: '',
    objects: {}
  }),

  methods: {
    onSearchValueChange() {
      if (!this.searchFilter) return;

      if (this.searchValue === '') {
        this.searchFilter(this.objects)
        return
      }
      const searchItems = this.objects.filter(obj => {
        const tmp = Object.entries(obj)
        console.log(tmp)
        for (const [key, value] of tmp) {
          const tmpVal = value?.toString()?.toLowerCase()
          const tmpSearch = this.searchValue?.toString()?.toLowerCase()
          const result = tmpVal?.includes(tmpSearch)
          if (result === true) return true
        }
        return false
      })
      this.searchFilter(searchItems)
    }
  },
  watch: {
    'searchByOther$'() {
      console.log('aaaaaaaaaaaaaa')
    }
  }
}
</script>

<style scoped>
.upper {
  text-transform: uppercase;
}
</style>